export default __webpack_public_path__ + "static/media/foreign-cover-1.751f986d.jpg";